import { UnmapMultipleSPoCsValidationLoader } from "./UnmapMultipleSPoCsValidationLoader";
import { UnmapMultipleSPoCsValidationResult } from "./UnmapMultipleSPoCsValidationResult";
import {
  Dialog,
  FoundationColorTokens,
  Spacing,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { observer } from "mobx-react";
import { TFunction } from "i18next";
import { Instance } from "mobx-state-tree";
import { SPoCDownloadAndUnmapStore } from "../../store/SPoCDownloadAndUnmapStore";
import { DeveloperErrorFlow } from "@pulse/shared-components";

interface UnmapMultipleSPoCsValidationDialogProps {
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  typography: Typography;
  spacing: Spacing;
  spocDownloadAndUnmapStore: Instance<typeof SPoCDownloadAndUnmapStore> | null;
}

export const UnmapMultipleSPoCsValidationDialog = observer(
  ({
    t,
    tokens,
    typography,
    spacing,
    spocDownloadAndUnmapStore,
  }: UnmapMultipleSPoCsValidationDialogProps): React.ReactElement => {
    if (spocDownloadAndUnmapStore === null) {
      return <DeveloperErrorFlow />;
    }

    const getSecondaryButtonText = (): string | undefined => {
      if (spocDownloadAndUnmapStore.isFileValidated) {
        return t("common.done");
      }
      return undefined;
    };

    const getValidationDialogContent = (): React.ReactElement => {
      if (spocDownloadAndUnmapStore.isRPCLoading) {
        return (
          <UnmapMultipleSPoCsValidationLoader
            t={t}
            spacing={spacing}
            tokens={tokens}
            typography={typography}
            spocDownloadAndUnmapStore={spocDownloadAndUnmapStore}
          />
        );
      } else if (spocDownloadAndUnmapStore.isFileValidated) {
        return (
          <UnmapMultipleSPoCsValidationResult
            t={t}
            spacing={spacing}
            tokens={tokens}
            typography={typography}
            spocDownloadAndUnmapStore={spocDownloadAndUnmapStore}
          />
        );
      } else {
        return <></>;
      }
    };

    return (
      <Dialog
        open={
          spocDownloadAndUnmapStore.isUnmapMultipleSPoCsValidationDialogVisible
        }
        title={t("projects.userAccess.unmapSPoCs.validationTitle", {
          defaultValue: t("projects.userAccess.addMultipleSPoCsDialog.title"),
        })}
        secondaryButtonText={getSecondaryButtonText()}
        isSecondaryButtonDisabled={spocDownloadAndUnmapStore.isRPCLoading}
        contentPadding={spacing.spaceLG}
        onSecondaryButtonClick={async () => {
          if (!spocDownloadAndUnmapStore.isRPCLoading) {
            spocDownloadAndUnmapStore.setIsUnmapMultipleSPoCsValidationDialogVisible(
              false,
            );
          }
        }}
        isPrimaryButtonDisabled={true}
        onPrimaryButtonClick={async () => {}}
        primaryButtonText={undefined}
        width="560px"
      >
        {getValidationDialogContent()}
      </Dialog>
    );
  },
);
